document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.Tally !== 'undefined' && typeof window.Tally.loadEmbeds === 'function') {
    window.Tally.loadEmbeds();
  } else {
    document.querySelectorAll('iframe[data-tally-src]:not([src])').forEach((iframeEl) => {
      iframeEl.src = iframeEl.dataset.tallySrc;
    });
  }

  const modal = document.querySelector('.free-design__success-modal');
  if (!modal) return;

  const closeButton = modal.querySelector('.free-design__success-close');
  let previousFocus = null;

  const closeModal = () => {
    if (!modal.classList.contains('is-visible')) return;
    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
    removeTrapFocus(previousFocus?.isConnected ? previousFocus : null);
    previousFocus = null;
  };

  const openModal = () => {
    if (modal.classList.contains('is-visible')) return;
    previousFocus = document.activeElement;
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    trapFocus(modal, closeButton || modal);
  };

  closeButton?.addEventListener('click', closeModal);

  modal.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal();
  });

  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://tally.so') return;

    const iframe = modal.closest('.free-design')?.querySelector('.free-design__iframe');
    if (!iframe || event.source !== iframe.contentWindow) return;

    let message;
    let formUrl;
    try {
      message = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      formUrl = new URL(iframe.dataset.tallySrc || iframe.src);
    } catch {
      return;
    }

    const formId = formUrl.pathname.match(/^\/embed\/([a-zA-Z0-9]+)\/?$/)?.[1];
    if (formUrl.origin !== 'https://tally.so' || !formId) return;
    if (!message || typeof message !== 'object' || Array.isArray(message)) return;
    if (message.event !== 'Tally.FormSubmitted') return;

    const payload = message.payload;
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return;
    if (payload.formId !== formId || typeof payload.id !== 'string' || !payload.id.trim()) return;

    openModal();
  });
});
